<template>
  <v-container>
    <s-date-picker
      v-model="date"
      label="abc"
      typeable
    />
    {{ date }}
    <!-- {{ euid }} -->

    <br><br>

    <v-btn @click="testClick">
      TEst
    </v-btn>

    <b>encryptedFilePassword</b><br>
    {{ encryptedFilePassword }}

    <s-encrypt-password-dialog
      ref="passwordDialog"
      :encrypted-file-password="encryptedFilePassword"
    />

    <v-btn @click="clickHandlerB">
      ABCCCC
    </v-btn>

    <v-btn @click="clickHandlerC">
      EEEE
    </v-btn>
    <s-search-staff-muti-new
      v-model="euids"
      label="muti"
    />
    <!-- <s-search-staff-new
      v-model="euid"
      is-share-cache
      show-group
      show-support-staff
      label="AAA"
      @dataChange="staff = $event"
    /> -->

    <!-- <v-btn @click="euid = '71'">
      Change Group
    </v-btn>

    {{ euid }}
    {{ staff }} -->

    <!-- <s-search-staff-new
      v-model="euid1"
      is-share-cache
      show-group
      show-support-staff
      label="AAA"
      :staff.sync="staff1"
    />

    {{ euid1 }}
    {{ staff1 }}

    <s-search-staff-new
      v-model="euid2"
      is-share-cache
      show-group
      show-support-staff
      label="AAA"
      :staff.sync="staff2"
    />

    <s-search-staff-new
      v-model="euid3"
      is-share-cache
      show-group
      show-support-staff
      label="AAA"
      :staff.sync="staff3"
    />

    {{ staff2 }} -->

    <s-search-staff-muti-new
      v-model="euids"
      is-share-cache
      show-group
      show-support-staff
      label="ABC"
      @dataChange="staffs = $event"
    />
    {{ euids }}
    <!-- {{ staffs }} -->

    <!-- <v-btn @click="euids=['4','5','EU000000012']">
      ABC
    </v-btn> -->

    <!-- <s-search-staff-muti-new
      v-model="euids2"
      is-share-cache
      show-group
      show-support-staff
      label="ABC"
      @dataChange="staffs2 = $event"
    />
    {{ staffs2 }}

    <s-search-staff-muti-new
      v-model="euids3"
      is-share-cache
      show-group
      show-support-staff
      label="ABC"
      @dataChange="staffs3 = $event"
    />
    {{ staffs3 }}

    <s-search-staff-muti-new
      v-model="euids4"
      is-share-cache
      show-group
      show-support-staff
      label="ABC"
      @dataChange="staffs4 = $event"
    />
    {{ staffs4 }}

    <s-search-staff-muti-new
      v-model="euids5"
      is-share-cache
      show-group
      show-support-staff
      label="ABC"
      @dataChange="staffs5 = $event"
    />
    {{ staffs5 }}

    <br><br>

    <br><br>

    <br><br>

    <br><br>

    <v-btn @click="euid = 'EU000000012'">
      Change euid
    </v-btn>

    <v-btn @click="cDialog = true">
      AAA
    </v-btn>

    <s-confirm-dialog
      v-model="cDialog"
      message="AA"
    />
    <br><br><br>
    <br>
    <v-btn @click="clickHandler('3')">
      3
    </v-btn>
    <v-btn @click="clickHandler('4')">
      4
    </v-btn>
    <v-btn @click="clickHandler('EU000000010')">
      EU000000010
    </v-btn>
    <br>
    {{ euids }}
    <br>
    {{ staffs }} -->
    <!-- <ol>
      <li
        v-for="(staff, index) in staffs"
        :key="index"
      >
        {{ staff }}
      </li>
    </ol> -->

    <!-- <v-icon>{{ svgPath }}</v-icon> -->
    <p>
      Testing page 10:43
    </p>
  </v-container>
</template>

<script>
/* eslint-disable no-unused-vars */

import jwtTokenApi from '@/api/general/jwtToken.js'
import SDatePicker from '@/components/SDatePicker'
import SSearchStaff from '@/components/SSearchStaff'
import SSearchStaffNew from '@/components/SSearchStaffNew'
import SSearchStaffMutiNew from '@/components/SSearchStaffMutiNew'
import SConfirmDialog from '@/components/SConfirmDialog'
import constant from '../constant/constant'
// import { getAuthCode } from '@/utils/govappUtil'

// import { mdiAccount } from '@mdi/js'

export default {
  components: {
    SDatePicker,
    // SSearchStaff,
    // SSearchStaffNew,
    SSearchStaffMutiNew
    // SConfirmDialog
  },
  inject: ['appUI'],
  data: function () {
    return {
      date: null,
      test: null,
      cDialog: false,
      euid: 'EU000000009',
      euid1: 'EU000000012',
      euid2: 'EU000000012',
      euid3: 'EU000000011',
      euid4: 'EU000000012',
      euid5: 'EU000000012',
      staff1: null,
      staff2: null,
      staff3: null,
      staff4: null,
      staff5: null,
      // euids: [],
      euids: ['3', '4', 'EU000000010'],
      euids2: ['3', '4', 'EU000000010'],
      euids3: ['3', '4', 'EU000000010'],
      euids4: ['3', '4', 'EU000000011'],
      euids5: ['3', '4', 'EU000000010'],
      staff: { 'euid': 'EU000000012', 'staffCode': '0000000159', 'chinName': '陳繼民', 'portName': 'CHAN KAI MAN', 'nickName': 'SIMON CHAN', 'entityInternalStaffCode': '237', 'subunitId': 32, 'subunitAbbr': 'DATE', 'subunitChinName': '選舉技術輔助處', 'subunitPortName': 'Divisão de Apoio Técnico-Eleitoral', 'groupId': null, 'groupAbbr': null, 'groupChinName': null, 'groupPortName': null, 'email': 'kmchan@safp.gov.mo', 'isDefaultStaff': null, 'definedGroupId': null, 'definedGroupAbbr': null, 'definedGroupChinName': null, 'definedGroupPortName': null, 'recordType': 'Staff' },
      staffs: [],
      staffs2: [],
      staffs3: [],
      staffs4: [],
      staffs5: [],
      preCacheStaffs: [ { 'euid': 'EU000000010', 'staffCode': '0000000770', 'chinName': '區子達', 'portName': 'AO CHI TAT', 'nickName': 'DARIAN AO', 'entityInternalStaffCode': '832', 'subunitId': 10, 'subunitAbbr': 'DAIDGE', 'subunitChinName': '電子政務資訊應用及發展處', 'subunitPortName': 'Divisão da Aplicação de Informação e Desenvolvimento do Governo Electrónico', 'groupId': 3554, 'groupAbbr': 'GTDPEGI', 'groupChinName': '內部管理及流程電子化工作組', 'groupPortName': 'Grupo de trabalho para o desenvolvimento de procedimentos electrónicos e gestão interna', 'email': 'chitata@safp.gov.mo', 'isDefaultStaff': null, 'definedGroupId': null, 'definedGroupAbbr': null, 'definedGroupChinName': null, 'definedGroupPortName': null, 'recordType': 'Staff', 'description': 'AO CHI TAT 區子達 (DARIAN AO) EU000000010', 'id': 'EU000000010' }, { 'euid': null, 'staffCode': null, 'chinName': null, 'portName': null, 'nickName': null, 'entityInternalStaffCode': null, 'subunitId': null, 'subunitAbbr': null, 'subunitChinName': null, 'subunitPortName': null, 'groupId': null, 'groupAbbr': null, 'groupChinName': null, 'groupPortName': null, 'email': null, 'isDefaultStaff': null, 'definedGroupId': 4, 'definedGroupAbbr': 'string', 'definedGroupChinName': 'string', 'definedGroupPortName': 'string', 'recordType': 'Group', 'description': 'string - string string', 'id': '4' }, { 'euid': null, 'staffCode': null, 'chinName': null, 'portName': null, 'nickName': null, 'entityInternalStaffCode': null, 'subunitId': null, 'subunitAbbr': null, 'subunitChinName': null, 'subunitPortName': null, 'groupId': null, 'groupAbbr': null, 'groupChinName': null, 'groupPortName': null, 'email': null, 'isDefaultStaff': true, 'definedGroupId': 3, 'definedGroupAbbr': 'testGroup NEW', 'definedGroupChinName': '測試群組3 NEW NEW', 'definedGroupPortName': 'testing Group NEW NEW', 'recordType': 'Group', 'description': 'testGroup NEW - 測試群組3 NEW NEW testing Group NEW NEW', 'id': '3' } ],
      path: constant.PUBLIC_PATH,
      encryptedFilePassword: `-----BEGIN PGP MESSAGE-----

wV4Ddy1BcJDFo40SAQdAYbD3EnBrQ1HRrhgqVxEBNuxvn6pV1sGMcbUCRdBt
GnIwmm5obNdN+Dsq+7AWX8aAvB4wK1jUVcQm3Fdkq44us1cAukibdB20LpUa
qrVBkeqT0sFYAYlBdS9NmQhI+43AH15U7p8ynQhl+v0uD1IwY1Pv0hvsSuZZ
/7C5M9r8PrQ0dxWoA22uPd/0rCmmRPbb49rNTzA6Tqw+VOGxBz2JPg0XOoPT
s9ztlGBycFAQRgqtQf8lkBxNMbUq/7syowK94yJiKHVUiwYYaaM9P4NB/7i6
khNpyLBPPDmW8CFRCMP7W9SCikWLcMqfvrQ9wUK4J3vXDM1l6P3PJ9POR8y7
ASuS+L/oui9DmoEg2yJqJaYWKx42wZs9YwPpToghG6M45lEHbhF7TDLXeRXE
8WAg0TGqQdIgL+inY8+KbJYrkOFiw8ByL/lW7BSNNO0NVm5sL/ybXASDUhkf
TVFhMKd1/nlmVQA0Rf31HrZwiUBJrAZWHkXQKD1uvWfzUInYsKk2t8r6sqje
cKgie+knHpbWNM8kLt3DLEL3AkwR2xa4cVgz1qrJhLN5D1KSjQDX7ZwLb6hD
0YWLNJAahnqyDRvI7JtSofZgsX5B7AS3fEY6vfCQNidrNJjyHVCclQ59U8hP
6Ialqfn4U7y8svzTec6QWS+84fiCxpuKVr5YXPYUiID31CW6p/Oig/3btRRG
CsvXkQl7SXyF9j/Cp5/Pd8e2hhBEHoRxq+wqQiDYah2f2/5KPCEyroj+VMl3
2SA2b9J0Xkod8Qarj9/xRzxrJStAepNtAjcZXMUdO9r43fajbpCCRgWXoQxK
jsbo6p0=
=ko6+
-----END PGP MESSAGE-----
`
      // svgPath: mdiAccount
    }
  },
  computed: {
  },
  async created () {

  },
  mounted () {

  },
  methods: {
    clickHandler: function (value) {
      this.euids.push(value)
    },
    clickHandlerB: function () {
      this.appUI.appDialog.show({
        message: 'hello ho',
        persistent: true
      }).onOk(() => {
        console.log('OK')
      }).onCancel(() => {
        console.log('Cancel')
      }).onDismiss(() => {
        console.log('Dismiss')
      })
    },
    clickHandlerC: function () {
      this.appUI.appDialog.show({
        message: 'JJKJKJK',
        maxWidth: 600
      }).onOk(() => {
        console.log('OK 2')
      }).onCancel(() => {
        console.log('Cancel 2')
      }).onDismiss(() => {
        console.log('Dismiss 2')
      })
    },
    testClick: async function () {
      let filePassword = await this.$refs.passwordDialog.getPassword()
      console.log(filePassword)
    }
  }
}
</script>
